import {useDashboard} from '../../../hooks/kpi/useDashboard'
import {formatMonetaryToBr} from '../../../utils/formatMonetaryToBr'
import {ChartSalesByFranchises} from './componente/charts/ChartSalesByFranchises'

interface SalesProps {
  className: string
}

export function SalesByFranchises({className}: SalesProps) {
  const {query} = useDashboard()
  const salesByProduct = query.data?.salesByFranchises?.itens ?? []
  const totalPriceSales = query.data?.salesByFranchises?.total ?? 0
  const isLoading = query.isLoading

  return (
    <>
      {isLoading && (
        <div className={`card card-flush`} style={{minHeight: '150px'}}>
          <div className='card-body pt-1 pb-4 d-flex flex-wrap flex-center p-4 px-10'>
            <div className='d-flex flex-center w-100'>
              <div className='text-center w-100 align-items-center justify-content-center'>
                <span>Carregando...</span>
              </div>
            </div>
          </div>
        </div>
      )}
      {!isLoading && (
        <div className={`card card-flush ${className}`}>
          <div className='card-header pt-5'>
            <div className='card-title d-flex flex-column'>
              <div className='d-flex align-items-center'>
                <span className='fs-2hx fw-bold text-dark me-2 lh-1 ls-n2'>
                  {formatMonetaryToBr(totalPriceSales)}
                </span>
              </div>
              <span className='text-gray-400 pt-1 fw-semibold fs-6'>Vendas Por franquia</span>
            </div>
          </div>
          <div className='card-body pt-1 pb-4 d-flex flex-wrap flex-start p-4 px-10'>
            <div className='d-flex flex-center w-100'>
              <ChartSalesByFranchises className='w-100 h-100' sales={salesByProduct} />
            </div>
          </div>
        </div>
      )}
    </>
  )
}
